import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import PactometroCheck from './checks';
import PactometroBarras from './barras';
import './index.scss';

const sel = [];
const PactometroCheckContainer = ({
  seatData,
  totalSeat,
  selecteds = sel,
  type = 'GENERAL',
  onChange
}) => {
  const [selectedsId, setSelectedsId] = useState(selecteds);
  const filterData = seatData.filter(current => current.seats >= 1);
  const totalVotes = filterData.reduce(
    (tot, current) => tot + current.votes,
    0
  );
  useEffect(() => {
    setSelectedsId(selecteds);
  }, [selecteds]);
  return (
    <div className="containerPactometro">
      <div className="content-pactos-barras">
        <PactometroBarras
          data={filterData}
          selecteds={selectedsId}
          totalSeat={totalSeat}
          totalVotes={totalVotes}
          type={type}
        />
      </div>
      <div className="content-pactos">
        <p className="legend">
          *Pincha sobre cada partido para sumar sus{' '}
          {type === 'REGIONAL' || type === 'GENERAL'
            ? ' escaños'
            : ' concejales'}
        </p>
        <div className="pactosScrollContent">
          <div className="pactosScroll">
            <PactometroCheck
              data={filterData}
              onChange={val => {
                setSelectedsId(val);
                onChange && onChange(val);
              }}
              selecteds={selecteds}
              type={type}
              pactometroType="noSimple"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

PactometroCheckContainer.propTypes = {
  seatData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      votes: PropTypes.number.isRequired,
      id: PropTypes.string.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func
};

export default PactometroCheckContainer;
